import React from "react";
import {useSearchParams} from "react-router-dom";
import {useGetAssetsInfiniteQuery} from "hooks";
import Arrow from "images/objectPanel/ic_back_arrow.svg";
import {ASSET_GENRE_TITLE, ASSET_LIST_TITLE, ASSET_LIST_TYPE_BY_PROP, ASSET_TYPE, MENU, SEARCH_PARAMS} from "components/Layout/constants";
// import Dropdown from "components/dropdowns/Dropdown";
import ExpandedList from "../ExpandedList";
import styles from "./index.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentSearchParams} from "store/actions/assetLibrary";

function MoreAsset() {
  const assetSearchParams = useSelector(state => state.assetLibrary.currentSearchParams);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentType = searchParams.get(SEARCH_PARAMS.TYPE);
  const dispatch = useDispatch();
  const listType = ASSET_LIST_TYPE_BY_PROP[currentType];
  const handleParams = () => {
    const params = assetSearchParams;
    return params;
  };
  const {data, fetchNextPage, hasNextPage} = useGetAssetsInfiniteQuery(handleParams());
  // const [selectedOption, setSelectedOption] = useState(genreList?.[0]);
  // const selectOption = type => {
  //   setSelectedOption(type);
  // };
  const handleGoBack = () => {
    searchParams.delete(SEARCH_PARAMS.TYPE);
    setSearchParams(searchParams);
    dispatch(setCurrentSearchParams({}));
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <button onClick={handleGoBack}>
          <img src={Arrow} alt="back_button" />
        </button>
        <h3 className={styles.title}>{ASSET_LIST_TITLE[currentType] || ASSET_GENRE_TITLE[currentType]}</h3>
      </header>
      {/* 세부 카테고리 추가된 이후 표시 */}
      {/* <Dropdown list={genreList} selectedOption={selectedOption} onSelectOption={selectOption} /> */}

      <ExpandedList listType={listType} data={data} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} />
    </div>
  );
}

export default MoreAsset;
